module.exports = __webpack_public_path__ + "img/q1-opt-b.98e808e6.png";